import React from "react";
import { Card, CardBody, CardTitle } from "reactstrap";
import ReactApexChart from "react-apexcharts";

const FinansGrafik = () => {
  // Statik veya API'den gelecek örnek grafik verisi
  const series = [{ name: "Sistem Cirosu", data: [4200, 8500, 10100, 5600, 3700, 10500, 3800, 5800, 9200, 8200, 7200, 3200] }];
  
  const options = {
    chart: { type: "area", height: 240, toolbar: { show: false } },
    colors: ["#556ee6"],
    dataLabels: { enabled: false },
    stroke: { curve: "smooth", width: 2 },
    fill: { type: "gradient", gradient: { shadeIntensity: 1, opacityFrom: 0.45, opacityTo: 0.05, stops: [20, 100, 100, 100] } },
    xaxis: { categories: ["Oca", "Şub", "Mar", "Nis", "May", "Haz", "Tem", "Ağu", "Eyl", "Eki", "Kas", "Ara"] },
    yaxis: { labels: { formatter: (value) => value + " TL" } }
  };

  return (
    <Card className="shadow-sm border-0">
      <CardBody>
        <CardTitle className="mb-3">Aylık Ciro Özeti</CardTitle>
        <ReactApexChart series={series} options={options} type="area" height={240} className="apex-charts" />
      </CardBody>
    </Card>
  );
};

export default FinansGrafik;